import {Model} from './model';
import {Address} from './address';
export class Community {

  id: string;
  name: string;
  code: string;
  builderName: string;
  builderDirectory: string;
  address: Address;
  models: Model[];

  // constructor(public name: string,
  //             public code: string,
  //             public builderName: string,
  //             public builderDirectory: string,
  //             public address: Address,
  //             public models: Model[]) {}

  constructor(public data: any) {
    const json: JSON = data;

    this.id = json['id'];
    this.name = json['name'];
    if (json['address']) {
      this.address = new Address(json['address']);
    }
    this.models = [];
    for (const m of json['models']) {
      // const model: Model = new Model(m);
      this.models.push(new Model(m));
    }
  }

  cityStateString() {
    if (this.address) {
      if (this.address.city && this.address.state) {
        return this.address.city + ', ' + this.address.state;
      } else if (this.address.city) {
        return this.address.city;
      } else if (this.address.state) {
        return this.address.state;
      }
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/model/community.ts